import React from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

// Функция для добавления параметров к URL, если они отсутствуют
const ensureParameterizedUrl = (to: string): string => {
  const timestamp = Date.now();
  
  if (to === '/knowledge') {
    return '/knowledge/root';
  } else if (to === '/chat') {
    return `/chat/default-${timestamp}`;
  } else if (to === '/studio' || to === '/dashboard') {
    return `/studio/home-${timestamp}`;
  } else if (to === '/roadmap') {
    return `/roadmap`;
  } else if (to === '/roadmap/result') {
    return `/roadmap/result`;
  } else if (to === '/task/result') {
    return `/task/result/new-${timestamp}`;
  } else if (to.startsWith('/articles/')) {
    // Проверяем наличие параметров в пути статей
    const parts = to.split('/');
    if (parts.length === 3) {
      // Специальная обработка для Reels
      if (parts[2] === 'reels') {
        return '/reels';
      }
      return `${to}/new-${timestamp}`;
    }
  }
  
  return to;
};

// Интерфейс для пропсов CustomLink, наследует все пропсы Link
interface CustomLinkProps extends Omit<LinkProps, 'to'> {
  to: string;
}

/**
 * Пользовательский компонент Link, гарантирующий наличие параметров в URL
 */
export const CustomLink: React.FC<CustomLinkProps> = ({ to, ...props }) => {
  // Проверяем и корректируем URL
  const correctedTo = ensureParameterizedUrl(to);
  
  return <RouterLink to={correctedTo} {...props} />;
}; 